module.exports = __webpack_public_path__ + "img/how-to-get-company.0a48ef13.svg";